/**
 * Multi-font — ฝึกอ่านตัวอักษรเดียวกันในหลายทรง
 *
 * DJT ฝึกแค่ ぎ ตัวเดียว · เราสุ่มทุกข้อ เพราะเป้าหมายคืออ่านมังงะ/เกม/ป้ายจริง
 * ปัญหาที่แก้: り มี 2 ทรง, き/さ ขีดล่างต่อ-แยก, ゆ หัวปิด-เปิด (NOTES.md §3)
 *
 * ฟอนต์โหลดจาก /fonts/*.woff2 (self-host — PWA ต้องทำงาน offline)
 * ยังไม่ได้ดึงไฟล์ → fallback เป็น system font ทรงใกล้เคียง แอปไม่พัง
 */

export interface FontChoice {
  id: string
  label: string
  /** ทรงนี้เจอที่ไหนในชีวิตจริง */
  where: string
  stack: string
}

export const FONTS: FontChoice[] = [
  {
    id: 'sans',
    label: 'ゴシック',
    where: 'เว็บ · แอป · ป้าย',
    stack: "'Noto Sans JP','Yu Gothic UI','Hiragino Kaku Gothic ProN',Meiryo,sans-serif",
  },
  {
    id: 'serif',
    label: '明朝',
    where: 'หนังสือ · นิยาย',
    stack: "'Noto Serif JP','Yu Mincho','Hiragino Mincho ProN','MS Mincho',serif",
  },
  {
    id: 'maru',
    label: '丸ゴシック',
    where: 'โปสเตอร์ · เกมน่ารัก',
    stack: "'Zen Maru Gothic','Rounded Mplus 1c','Hiragino Maru Gothic ProN',sans-serif",
  },
  {
    id: 'kyokasho',
    label: '教科書体',
    where: 'ตำราเรียน · ลายมือครู',
    stack: "'Klee One','UD Digi Kyokasho N-R','YuKyokasho','Yu Mincho',serif",
  },
  {
    id: 'brush',
    label: '筆書体',
    where: 'logo อนิเมะ · ป้ายร้าน',
    stack: "'Yuji Syuku','Shippori Mincho','Yu Mincho',serif",
  },
]

const FALLBACK = FONTS[0] as FontChoice

export function fontById(id: string): FontChoice {
  return FONTS.find((f) => f.id === id) ?? FALLBACK
}

/** สุ่มฟอนต์ให้แต่ละข้อ — จำกัดเฉพาะที่เปิดไว้ */
export function pickFont(enabled: Set<string>): FontChoice {
  const pool = FONTS.filter((f) => enabled.has(f.id))
  if (pool.length === 0) return FALLBACK
  return pool[Math.floor(Math.random() * pool.length)] ?? FALLBACK
}
